<template>
    <div class="container" id="accident-analysis">
        <AccidentStatistics :data="accidentData" :time="time" :status="statisticsStatus" @changed="dateChange">
        </AccidentStatistics>
        <AccidentRelative :data="barData" :time="time" :status="relativeStatus" @changed="dateChange">
        </AccidentRelative>
        <AccidentRank :data="rankData" :time="time" :status="rankStatus" @showPopover="showPopover"  :popoverData="popoverData"
            @closePopover="closePopover" @changed="dateChange">
        </AccidentRank>
        <AccidentTimeline :data="timelineData" :accidentType="accidentType" :status="timelineStatus"
            :loadMoreStatus="timelineStatusMore" @showDetail="showDetail" @changed="classifyChanged"
            @loadMore="getTimelineDataMore">
        </AccidentTimeline>

        <Details v-if="isShowDetail" :dialogVisible="isShowDetail" :status="accidentDetailStatus" :detail="detail"
            @closeDetail="closeDetail" />

        <!-- <div class="popover" v-if="isShowPopover" :style="{left: mouseX, top: mouseY}">
            <Popover :data="rankPieDataWithColor"></Popover>
        </div> -->
    </div>
</template>

<script>
    import AccidentStatistics from '../../components/accidentManagement/AccidentStatistics';
    import AccidentRelative from '../../components/accidentManagement/AccidentRelative';
    import AccidentRank from '../../components/accidentManagement/AccidentRank';
    import AccidentTimeline from '../../components/accidentManagement/AccidentTimeline';
    import Details from '../../components/accidentManagement/UnconfirmedEvent/Details';

    import Popover from '../../components/accidentManagement/rank/Popover';

    import {
        arrayUnique
    } from '../../util/Utils';
    import {
        dayStart,
        dayEnd,
        weekStart,
        weekEnd,
        monthStart,
        monthEnd
    } from '../../util/DateUtil2';

    import {
        GetAccidentStatistics,
        GetAccidentCompareDay,
        GetAccidentCompareWeek,
        GetAccidentCompareMonth,
        GetAccidentRank,
        GetAccidentRankDetail,
        GetAccidentTimeline,
        GetAccidentDetailForId,
        GetAccidentValue,
        AlarmStatistics,
        AlarmNewEvent
    } from '../../api/accident';

    /**
     * 环形图的颜色
     */
    const COLORS = ['#FF5555', '#F5AA00', '#0D94FF', '#5D7092'];
    /**
     * 报警类型, 后端根据这些类型判断要查看的事件类型, ''表示全部的报警事件
     */
    //  TELEMETRY_OVERRUN("越限异常"),
    // EQUIPMENT_FAILURE("网关离线"),
    // TELEMETRY_DISPLACEMENT("跳闸报警"),
    // DEVICE_EXCEPTION("设备异常"),
    // DEVICE_FAILURE("回路故障")
    const TYPES = ['', 'URGENT', 'HIDDEN_DANGER', 'NOTICE'];
    // const TYPES = ['', 'TELEMETRY_DISPLACEMENT', 'TELEMETRY_OVERRUN', 'EQUIPMENT_FAILURE'];
    // DEVICE_EXCEPTION
    /**
     * 数据为0的所有报警, 后端返回的数据, 如果value为0, 就会省略这一项, 导致页面出现bug, 
     * 所以请求到的数据需要合并到这个数据为0的数组中, 然后根据name去重
     */
    /**
     * 此处可能会出现bug: 在组件构建的时候获取当时时间, 然后据此算出当天当周当月, 但一直在这个页面的话这个时间可能不会动态更改,
     * 排除掉这种情况, 只获得一次应该可以减少不少不必要的计算
     */
    const now = new Date();
    const dayRange = [dayStart(now), dayEnd(now)];
    const weekRange = [weekStart(now), weekEnd(now)];
    const monthRange = [monthStart(now), monthEnd(now)];
    export default {
        components: {
            AccidentStatistics,
            AccidentRelative,
            AccidentRank,
            AccidentTimeline,
            Details,
            Popover
        },
        data() {

            return {
                all: '',
                // 是否显示详情
                isShowDetail: false,
                // 事件编号 - 用于请求详情页的数据
                code: '',

                ZEROPIEDATA: [],
                // 报警统计数据
                pieData: [{
                        num: 0,
                        name: '越限异常'
                    },
                    {
                        num: 0,
                        name: '网关离线'
                    },
                    {
                        num: 0,
                        name: '跳闸报警'
                    },
                    // {
                    //     num: 0,
                    //     name: '设备异常'
                    // },
                    // {
                    //     num: 0,
                    //     name: '回路故障'
                    // },
                ],
                rankPieData: [{
                        num: 100,
                        name: '越限异常'
                    },
                    {
                        num: 300,
                        name: '网关离线'
                    },
                    {
                        num: 700,
                        name: '跳闸报警'
                    },
                    // {
                    //     num: 600,
                    //     name: '设备异常'
                    // },
                    // {
                    //     num: 100,
                    //     name: '回路故障'
                    // },
                ],
                accidentData:{},
                popoverData:{},
                // 报警环比数据  昨日/今日
                barData: [
                    230,
                    0
                ],
                // 报警排名数据
                rankData: [],
                // 最新报警数据
                timelineData: [],
                // 当前所选择的时间段
                time: 0,
                accidentType: 0,

                // 当前页
                currentPage: 1,

                // status: loading | loaded | error
                statisticsStatus: 'loaded',
                relativeStatus: 'loaded',
                rankStatus: 'loaded',
                timelineStatus: 'loaded',

                // status: loading | loaded | no more
                timelineStatusMore: 'loaded',

                // status: loading | loaded | error
                accidentDetailStatus: 'loaded',

                // 详情页数据
                detail: null,

                //事件弹窗控制参数
                isShowPopover: false,
                mouseX: 0,
                mouseY: 0,
            }
        },
        mounted() {
            //请求同比的数据
            this.getBarData()
                .then(result => this.barData = result);
            //请求事件统计的数据
            this.getPieData()
                .then(result => this.pieData = result);
            //请求报警排行的数据
            this.getRankData()
                .then(result => this.rankData = result);
            //请求最新报警
            this.getTimelineData()
                .then(result => this.timelineData = result);
            //事件统计
            this.getAlarmStatistics();
        },
        methods: {
            async getAlarmStatistics(){
                // fault: 0  故障报警
                // hiddenDanger: 0  隐患
                // messageNotice: 0 信息通报
                // notice: 7 通知
                // operation: 0  操作命令
                // other: 0  其他
                // overrun: 0 越限异常
                // protections: 0 保护动作
                // sum: 7 总
                // switchDisplacement: 7  开关变位
                // urgent: 0 紧急
                let result = await AlarmStatistics({
                    start: this.timeRange[0],
                    end: this.timeRange[1],
                    projectId: this.projectId
                });
                this.accidentData = result.data.data.eventNum.all
                this.popoverData = result.data.data.eventNum
            },
            // 弹出详情页
            async showDetail(code) {
                // console.log(this.timeRange);
                this.accidentDetailStatus = 'loading';
                this.isShowDetail = true;

                this.detail = await this.getAccidentDetail(code);
                console.log(this.detail);
                if (this.detail == null) {
                    this.accidentDetailStatus = 'error';
                }
                // console.log(this.detail);

                this.accidentDetailStatus = 'loaded';
            },
            // 关闭详情页
            closeDetail() {
                this.isShowDetail = false;
            },
            // 事件改变
            dateChange(time) {
                this.time = time;
            },
            // 类型改变
            classifyChanged(classify) {
                this.accidentType = classify;
            },
            // 判断状态码 取出data
            transformForData(response) {
                const {
                    code,
                    data,
                    status
                } = response.data;
                if (code !== 200 && status !== true) {
                    console.error('response error: code is not 200 or status is not true');
                    return null;
                }

                return data;
            },
            // 点击报警排行, 显示分类数目
            showPopover: async function (mouseEvent, id) {
                try {
                    this.rankPieData = await this.getRankDetail(id)
                } catch (error) {
                    console.log('加载失败');
                }
                //console.log(this.rankPieData);
                this.mouseX = mouseEvent.clientX * 1.1 + 'px';
                this.mouseY = mouseEvent.clientY + 'px';
                this.isShowPopover = true;
            },
            // 关闭Popover
            closePopover: function () {
                this.isShowPopover = false;
            },
            // Mapper到最新报警的指定数据格式
            timelineDataMapper(data) {
                return data.map(item => {
                    return {
                        code: item.id,
                        timestamp: item.start_time,
                        loop: item.belong_type ? item.device_name : item.loop_name,
                        type: item.alarm_event_type,
                        description: item.alarm_type_desc,
                        belong_type: item.belong_type,
                        event_name:item.event_name
                    }
                })
            },
            // Mapper到详情页的指定数据格式
            accidentDetailMapper(data) {
                return {
                    loopId: data.loop_id,
                    img: data.device_img,
                    name: data.loop_name,
                    deviceName: data.device_name,
                    position: data.area_name,
                    code: data.id,
                    classify: data.alarm_event_type,
                    type: data.alarm_type_desc,
                    start: data.start_time,
                    end: data.end_time,
                    description: data.alarm_type_desc,
                    node: data.node,
                    realName: data.real_name,
                    event_name: data.event_name,
                    device: data.device_details,
                    loop_type:data.loop_type,
                    incident_type:data.incident_type,
                    incident_classification:data.incident_classification
                }
            },
            // Mapper到详情页快照数据的指定格式
            accidentValueMapper(data, node,type) {
                let snapshot = data.results[0].series;
                //console.log(snapshot);
                if (snapshot == undefined) {
                    return []
                }
                let temps = snapshot.map(item => {
                    return [item.tags.node, item.values[0][1]];
                });
                let map = new Map(temps);
                //console.log(map);
                return this.accidentValueFormat(map, node,type);
            },
            // 快照数据的指定格式
             accidentValueFormat(map, node,type) {
                // console.log(node)
                    if(type.classify=='TELEMETRY_OVERRUN'&&type.loop_type=='TRANSFORMER'){
                    return [{
                            title: '温度',
                            unit: '℃',
                            isDangerous: ['Temperature_A', 'Temperature_B', 'Temperature_C'].includes(node),
                            value: [{
                                    name: 'A',
                                    value: map.get('Temperature_A')?map.get('Temperature_A').toFixed(2):map.get('Temperature_A'),
                                    isDangerous: ['Temperature_A'].includes(node),
                                },
                                {
                                    name: 'B',
                                    value: map.get('Temperature_B')?map.get('Temperature_B').toFixed(2):map.get('Temperature_B'),
                                    isDangerous: ['Temperature_B'].includes(node),
                                },
                                {
                                    name: 'C',
                                    value: map.get('Temperature_C')?map.get('Temperature_C').toFixed(2):map.get('Temperature_C'),
                                    isDangerous: ['Temperature_C'].includes(node),
                                },
                                // {name: '均', value: map.get('Vvavg')},
                            ]
                        }, {
                            title: '风机状态',

                            isDangerous: [this.fengji].includes(node),

                            value: [{
                                isDangerous: [this.fengji].includes(node),
                                value: map.get(this.fengji)
                            }]
                        }, {
                            title: '负载',
                            unit: 'V',
                            value: (map.get('P') / 1000)?(map.get('P') / 1000).toFixed(2):(map.get('P') / 1000),
                            value: [{
                                isDangerous: ['P'].includes(node),
                                value: (map.get('P') / 1000).toFixed(2)
                            }, ]
                        }, {
                            title: '负载率',
                            unit: '%',
                            value: (map.get('P') / 1000)?(map.get('P') / 1000).toFixed(2):(map.get('P') / 1000),
                            value: [{
                                isDangerous: this.fengji.includes(node),
                                value: map.get(this.fengji)?map.get(this.fengji).toFixed(2):map.get(this.fengji)
                            }, ]
                        },
                        {
                            title: '容量',
                            unit: 'kVA',
                            value: (map.get('P') / 1000)?(map.get('P') / 1000).toFixed(2):(map.get('P') / 1000),
                            value: [{
                                isDangerous: this.fengji.includes(node),

                            }, ]
                        }
                    ]   
                }else{
                    return [{
                        title: '三相相电压',
                        unit: 'V',
                        isDangerous: ['Ua', 'Ub', 'Uc', 'Vvavg'].includes(node),
                        value: [{
                                name: 'A',
                                value: map.get('Ua')?map.get('Ua').toFixed(2):map.get('Ua')
                            },
                            {
                                name: 'B',
                                value: map.get('Ub')?map.get('Ub').toFixed(2):map.get('Ub')
                            },
                            {
                                name: 'C',
                                value: map.get('Uc')?map.get('Uc').toFixed(2):map.get('Uc')
                            },
                            // {name: '均', value: map.get('Vvavg')},
                        ]
                    }, {
                        title: '三相线电压',
                        unit: 'V',
                        isDangerous: ['Uab', 'Ubc', 'Uac', 'Vlavg'].includes(node),
                        value: [{
                                name: 'AB',
                                value: map.get('Uab')?map.get('Uab').toFixed(2):map.get('Uab')
                            },
                            {
                                name: 'BC',
                                value: map.get('Ubc')?map.get('Ubc').toFixed(2):map.get('Ubc')
                            },
                            {
                                name: 'AC',
                                value: map.get('Uac')?map.get('Uac').toFixed(2):map.get('Uac')
                            },
                            // {name: '均', value: map.get('Vlavg')},
                        ]
                    }, {
                        title: '电流',
                        unit: 'A',
                        isDangerous: ['Ia', 'Ib', 'Ic', 'Iavg'].includes(node),
                        value: [{
                                name: 'A',
                                value: map.get('Ia')?map.get('Ia').toFixed(2):map.get('Ia')
                            },
                            {
                                name: 'B',
                                value: map.get('Ib')?map.get('Ib').toFixed(2):map.get('Ib')
                            },
                            {
                                name: 'C',
                                value: map.get('Ic')?map.get('Ic').toFixed(2):map.get('Ic')
                            },
                            // {name: '均', value: map.get('Iavg')},
                        ]
                    }, {
                        title: '有功功率',
                        unit: 'W',
                        isDangerous: ['PAa', 'PAb', 'PAc', 'PA'].includes(node),
                        value: [{
                                name: 'A',
                                value: map.get('PAa')?map.get('PAa').toFixed(2):map.get('PAa')
                            },
                            {
                                name: 'B',
                                value: map.get('PAb')?map.get('PAb').toFixed(2):map.get('PAb')
                            },
                            {
                                name: 'C',
                                value: map.get('PAc')?map.get('PAc').toFixed(2):map.get('PAc')
                            },
                            // {name: '总', value: map.get('PA')}
                        ]
                    }, {
                        title: '无功功率',
                        unit: 'W',
                        isDangerous: ['PRa', 'PRb', 'PRc', 'PR'].includes(node),
                        value: [{
                                name: 'A',
                                value: map.get('PRa')?map.get('PRa').toFixed(2):map.get('PRa')
                            },
                            {
                                name: 'B',
                                value: map.get('PRb')?map.get('PRb').toFixed(2):map.get('PRb')
                            },
                            {
                                name: 'C',
                                value: map.get('PRc')?map.get('PRc').toFixed(2):map.get('PRc')
                            },
                            // {name: '总', value: map.get('PR')},
                        ]
                    }, {
                        title: '温度',
                        unit: '℃',
                        isDangerous: ['Temperature'].includes(node),
                        value: [{
                            name: 'T',
                            value: map.get('Temperature')
                        }, ]
                    }, {
                        title: '频率',
                        unit: 'Hz',
                        isDangerous: ['F'].includes(node),
                        value: [{
                            name: 'F',
                            value: map.get('F')
                        }, ]
                    }]
                }
                   
              
                },
            // 获取环比的数据,
            async getBarData() {
                this.relativeStatus = 'loading';
                let result = {};
                if (this.time === 0) {
                    result = await GetAccidentCompareDay(this.projectId);
                } else if (this.time === 1) {
                    result = await GetAccidentCompareWeek(this.projectId);
                } else if (this.time === 2) {
                    result = await GetAccidentCompareMonth(this.projectId);
                } else {
                    throw new Error('DateTabs value is not 0, 1, 2');
                }
                //console.log(result);

                let now = this.transformForData(result[0]);
                let last = this.transformForData(result[1]);
                // console.log(now, last)

                if (now === null || last === null) {
                    this.relativeStatus = 'error';
                    return;
                }

                this.relativeStatus = 'loaded';
                return [now.num, last.num];
            },
            // 获取统计的数据
            async getPieData() {
                this.statisticsStatus = 'loading';
                // console.log(this.timeRange[0],
                //     this.timeRange[1],
                // );
                let result = await GetAccidentStatistics({
                    start: this.timeRange[0],
                    end: this.timeRange[1],
                    projectId: this.projectId
                });
                result = this.transformForData(result);
                // console.log('getPieData:', result);
                if (result === null) {
                    this.statisticsStatus = 'error';
                    return;
                }
                // 后台对于数据为0的项不会返回, 故在此将它们补全出来
                if (result.eventNum.length < 4) {
                    // if (this.$store.state.project.currentProject.projectId == 3) {
                    //     this.ZEROPIEDATA = [{
                    //             num: 0,
                    //             name: '越限异常'
                    //         },
                    //         {
                    //             num: 0,
                    //             name: '网关离线'
                    //         },
                    //         {
                    //             num: 0,
                    //             name: '跳闸报警'
                    //         }
                    //     ]
                    // } else {
                        this.ZEROPIEDATA = [{
                                num: 0,
                                name: '紧急事件'
                            },
                            {
                                num: 0,
                                name: '隐患事件'
                            },
                            {
                                num: 0,
                                name: '通知事件'
                            },
                            //  {
                            //     num: 0,
                            //     name: '回路故障' 
                            // }
                        ]
                    // }

                    result.eventNum = arrayUnique([...result.eventNum, ...this.ZEROPIEDATA], 'name')
                }
                this.statisticsStatus = 'loaded';
                return result.eventNum;
            },
            // 获取排行的数据
            async getRankData() {
                this.rankStatus = 'loading';
                let result = await GetAccidentRank({
                    start: this.timeRange[0],
                    end: this.timeRange[1],
                    projectId: this.projectId
                });
                //console.log('getRankData: ', result, this.rankStatus);
                result = this.transformForData(result);
                if (result === null) {
                    this.rankStatus = 'error';
                    return;
                }

                this.rankStatus = 'loaded';
                return result.ranking;
            },
            // 点击获取排行的详情数据
            async getRankDetail(areaId) {
                let result = await GetAccidentRankDetail({
                    start: this.timeRange[0],
                    end: this.timeRange[1],
                    areaId: areaId
                });
                //console.log('getRankDetail: ', result);
                result = this.transformForData(result);
                if (result === null) {
                    // 弹窗提示未请求到站点详情数据
                    this.$message.error('未获得相关数据, 请稍后重试!');
                    return;
                }
                // 后台对于数据为0的项不会返回, 故在此将它们补全出来
                if (result.eventNum.length < 4) {
                    if (this.$store.state.project.currentProject.projectId == 3) {
                        this.ZEROPIEDATA = [{
                                num: 0,
                                name: '越限异常'
                            },
                            {
                                num: 0,
                                name: '网关离线'
                            },
                            {
                                num: 0,
                                name: '跳闸报警'
                            }
                        ]
                    }
                    result.eventNum = arrayUnique([...result.eventNum, ...this.ZEROPIEDATA], 'name')
                }
                return result.eventNum;
            },
            // 获取最新报警的数据
            async getTimelineData() {
                this.timelineStatus = 'loading';
                // 切换类型时初始化当前页为第一页
                this.currentPage = 1;
                // 切换类型时初始化timelineStatusMore
                this.timelineStatusMore = 'loaded';
                let result = await AlarmNewEvent({
                    incidentClassificationClass: TYPES[this.accidentType],
                    incidentTypeClass:"",
                    end:"",
                    start:"",
                    eventClass:"",
                    page: this.currentPage,
                    size: 20,
                    projectId: this.projectId
                });
                result = this.transformForData(result);
                if (result === null) {
                    this.timelineStatus = 'error';
                    return;
                }
                let resultMapper = this.timelineDataMapper(result.eventList.records);

                this.timelineStatus = 'loaded';
                if (result.eventList.records.length > 0 && result.eventList.total <= result.eventList.size) {
                    this.timelineStatusMore = 'noMore';
                }
                return resultMapper;
            },
            // 最新报警滚动加载更多
            async getTimelineDataMore() {
                this.timelineStatusMore = 'loading';
                this.currentPage++;
                // let result = await GetAccidentTimeline({
                //     type: TYPES[this.accidentType],
                //     page: this.currentPage,
                //     size: 20,
                //     projectId: this.projectId
                // });

                // result = this.transformForData(result);
                let result = await AlarmNewEvent({
                    incidentClassificationClass: TYPES[this.accidentType],
                    incidentTypeClass:"",
                    end:"",
                    start:"",
                    eventClass:"",
                    page: this.currentPage,
                    size: 20,
                    projectId: this.projectId
                });
                result = this.transformForData(result);
                if (result === null) {
                    return;
                }
                let resultMapper = this.timelineDataMapper(result.eventList.records);
                this.timelineData = arrayUnique([...this.timelineData, ...resultMapper], 'code')
                // no more
                if (this.currentPage >= result.eventList.pages) {
                    this.timelineStatusMore = 'noMore';
                } else {
                    this.timelineStatusMore = 'loaded';
                }
            },
            // 最新报警中点击查看报警的详情
            async getAccidentDetail(id) {
                let result = await Promise.all([GetAccidentDetailForId(id), GetAccidentValue(id)]);
                let result0 = this.transformForData(result[0]);
                let result1 = this.transformForData(result[1]);
                if (result0.details === null || result1.snapshot === null) {
                    return;
                }
                result0.details = this.accidentDetailMapper(result0.details)
                result1.snapshot = this.accidentValueMapper(result1.snapshot, result0.details.node,result0.details).filter((
                    item) => {
                    let obj = JSON.parse(result0.details.device)
                    if (item.title == '风机状态') {
                        if (item.value[0].value == 0) {
                            item.value[0].value = '关闭'

                        } else if (item.value[0].value > 0) {
                            item.value[0].value = '开启'
                        }
                    } else if (item.title == '负载') {

                        if (fzl == 0 || rl == 0) {
                            this.all = 0
                        } else {
                            var fzl = item.value[0].value
                            var rl = obj.电气.容量.split('k')
                            // console.log(fzl, rl[0])
                            this.all = fzl / rl[0]*100
                        }
                        // console.log(this.all)
                    } else if (item.title == '容量') {
                        item.value[0].value = obj.电气.容量.split('kVA')[0]
                    } else if (item.title == '负载率') {
                        // console.log(this.all)
                        item.value[0].value = this.all.toFixed(2)
                    }


                    return item
                });

                return {
                    infomation: result0.details,
                    data: result1.snapshot
                };
            }
        },
        computed: {
            fengji: function () {

                if (this.$store.state.project.currentProject.projectId == 4) {
                    return "Temperature_status_windopen"
                    //  console.log(value)
                } else {
                    return "Fan_Status"
                    //  console.log(value)
                }
            },
            // 根据tab切换日周月 返回指定的时间区间
            timeRange: function () {
                switch (this.time) {
                    case 0:
                        return dayRange;
                    case 1:
                        return weekRange;
                    case 2:
                        return monthRange;
                }
                return dayRange;
            },
            // 获取Vuex中的项目Id
            projectId: function () {
                return this.$store.getters.projectId;
            },
            // 给柱状图数据上附加上color字段
            rankPieDataWithColor: function () {
                return this.rankPieData.map((item, index) => {
                    return Object.assign({}, item, {
                        color: COLORS[index]
                    });
                })
            }
        },
        watch: {
            // 时间变化时, 重新获取报警统计, 报警环比, 报警排行的数据
            time: function (newData, oldData) {
                this.getBarData()
                    .then(result => this.barData = result);
                this.getPieData()
                    .then(result => this.pieData = result);
                this.getRankData()
                    .then(result => this.rankData = result);
                //事件统计
                this.getAlarmStatistics();
            },
            // 报警类型变化时, 重新获取最新报警的数据
            accidentType: function (newData, oldData) {
                this.timelineData = [];
                this.currentPage = 1;

                this.getTimelineData()
                    .then(result => this.timelineData = result);
            }
        }
    }
</script>

<style lang="less" scoped>
    .container {
        display: flex;
        flex-wrap: wrap;
        height: 100%;
        justify-content: space-between;
        align-content: space-between;

        .popover {
            position: absolute;
            .w(461);
            .h(288);
            background: #fff;
            transform: translateY(-80%);
            z-index: 2;

            .el-card {
                height: 100%;
            }
        }
    }
</style>